import { TAppState } from '../../types/appState';
import { currentOpenChatSelector } from '../currentOpenChatSelector';

export const selectIsOpponentContactsVisible = (state: TAppState): boolean => {
  const currentChat = currentOpenChatSelector(state);

  // Возвращаем значение из текущего чата или true по умолчанию
  return currentChat?.isOpponentContactsVisible ?? true;
};
